import {AbstractControl, ValidationErrors} from '@angular/forms';
import * as _ from 'lodash';

export function AgeStartEndValidation(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    const actual = control.value;

    const index = actual.groups.findIndex(group => {
      if (!areAgesValid(group)) {
        return false;
      }
      return group.startingAge > group.endingAge;
    });

    return index >= 0 ? {'ageStartEnd': {idx: index}} : null;
  }

  return null;
}

export function AgeOverlapValidation(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    const actual = control.value;

    return actual.groups.some((group, idx1) => {
      if (!areAgesValid(group)) {
        return false;
      }
      return actual.groups.some((checkGroup, idx2) => {
        if (idx1 === idx2 || !areAgesValid(checkGroup)) {
          return false;
        }
        return (checkGroup.startingAge >= group.startingAge && checkGroup.startingAge <= group.endingAge) ||
          (checkGroup.endingAge >= group.startingAge && checkGroup.endingAge <= group.endingAge);
      });
    }) ? {'ageOverlap': true} : null;
  }

  return null;
}

export function AgeUniqueName(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    const groupsWithName = _.filter(control.value.groups, 'ageGroupName');
    return _.uniqBy(groupsWithName, 'ageGroupName').length !== groupsWithName.length ?
      {'ageUniqueName': true} : null;
  }

  return null;
}

export function AgeRequired(control: AbstractControl): ValidationErrors | null {

  if (control.value) {
    const actual = control.value.groups;
    return actual.some(group => {
      return group.ageGroupName && group.defaultAgeGroup.groupType !== 'ADULT' &&
        (!isNumber(group.startingAge) || !isNumber(group.endingAge));
    }) ? {'ageRequired': true} : null;
  }

  return null;
}

function isNumber(parameter) {
  return !isNaN(parseInt(parameter, 0));
}

function areAgesValid(group) {
  return isNumber(group.startingAge) && isNumber(group.endingAge);
}
